var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoalFocusOutline = function SvgGoalFocusOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.259,77.26 C62.957,77.26 57.017,71.32 57.017,64.018 C57.017,56.717 62.957,50.777 70.259,50.777 C77.56,50.777 83.5,56.717 83.5,64.018 C83.5,71.32 77.56,77.26 70.259,77.26 M25.742,77.26 C18.441,77.26 12.5,71.32 12.5,64.018 C12.5,56.717 18.441,50.777 25.742,50.777 C33.043,50.777 38.984,56.717 38.984,64.018 C38.984,71.32 33.043,77.26 25.742,77.26 M70.259,14.74 C69.155,14.74 68.259,15.635 68.259,16.74 C68.259,17.844 69.155,18.74 70.259,18.74 C77.56,18.74 83.5,24.68 83.5,31.982 L83.5,52.993 C80.335,49.198 75.575,46.777 70.259,46.777 C61.429,46.777 54.138,53.451 53.143,62.018 L42.858,62.018 C41.862,53.451 34.571,46.777 25.742,46.777 C20.425,46.777 15.665,49.198 12.5,52.993 L12.5,31.982 C12.5,24.68 18.441,18.74 25.742,18.74 C26.846,18.74 27.742,17.844 27.742,16.74 C27.742,15.635 26.846,14.74 25.742,14.74 C16.235,14.74 8.5,22.474 8.5,31.982 L8.5,64.018 C8.5,73.526 16.235,81.26 25.742,81.26 C34.572,81.26 41.862,74.585 42.858,66.018 L53.143,66.018 C54.138,74.585 61.429,81.26 70.259,81.26 C79.766,81.26 87.5,73.526 87.5,64.018 L87.5,31.982 C87.5,22.474 79.766,14.74 70.259,14.74",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Goals-/-Focus"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })))));
};
export default SvgGoalFocusOutline;